(function() {
    'use strict';

    angular.module('GorillaBoy.services')
    .factory('GroupService', [
        '$http',
        '$q',
        'EndpointService',
        'AppConstants',
        GroupService
    ]);

    function GroupService ($http, $q, EndpointService, AppConstants) {
        var DEFAULT_PAGE_SIZE = 48;

        // AppConstant bindings
        var httpMethods = AppConstants.HttpMethods;

        var groupService = {},
            SERVICE_ROOT = function () {
                return EndpointService.endpoint() + 'group/';
            };

        groupService.getUsersInGroup = function (groupId, vendor, extensions, marker) {
            var config = {
                url: SERVICE_ROOT() + encodeURIComponent(groupId) + '/users',
                method: httpMethods.GET,
                params: {
                    vendor: vendor,
                    extension: extensions,
                    pageSize: DEFAULT_PAGE_SIZE
                }
            };
            if (marker) {
                config.params.marker = marker;
            }
            
            // prepare a deferred object and return its promise
            var deferred = $q.defer();
            
            $http(EndpointService.tokenize(config))
            .success(function(res) {
                angular.forEach(res.Users, function(value) {     
                    // Manually set entry type to USER. 
                    // As implied by function name, service API only users (not group) from a group. So one can safely assume the
                    // result only contains users.   
                    value.Type = AppConstants.CollaboratorTypes.USER;
                });
                deferred.resolve(res);
            }).error(function(error) {
                deferred.reject(error);
            });

            return deferred.promise;
        };

        return groupService;
    }

}());
